import { useIntl } from 'react-intl'
import FormatDateTime from 'components/utils/Formatters/FormatDateTime'

export interface PlatinumRetentionMessageProps {
  variant: 'current-year' | 'next-year'
  creditsRemaining: number
  nightsRemaining: number
  targetCredits: number
  targetNights: number
  reviewDate: string
  reviewYearStart: string
}

function LoyaltyPlatinumRetentionMessage({ variant, creditsRemaining, nightsRemaining, targetCredits, targetNights, reviewDate, reviewYearStart }: PlatinumRetentionMessageProps) {
  const intl = useIntl()
  const expiryDate = <FormatDateTime value={reviewDate} day="numeric" month="short" year="numeric" />
  if (variant === 'next-year') {
    return intl.formatMessage({
      id: 'A88WWxLKKg0G3onoQ_nr',
      defaultMessage: 'To retain Platinum, you will need to earn {credits, number} Status Credits and {nights, plural, one {# night} other {# nights}} from {startDate} to {expiryDate}.',
      description: 'Platinum retention requirements for the next membership year in the double rewards selection',
    }, {
      credits: targetCredits,
      nights: targetNights,
      startDate: <FormatDateTime value={reviewYearStart} day="numeric" month="short" year="numeric" />,
      expiryDate,
    })
  }
  if (creditsRemaining === 0 && nightsRemaining === 0) {
    return intl.formatMessage({
      id: 'THc2VuTvBH6BHJzEW2Uv',
      defaultMessage: 'You have enough status credits and nights to retain Platinum for this membership year.',
      description: 'Platinum member has met their current year retention requirements in the double rewards selection',
    })
  }
  return intl.formatMessage({
    id: '2P7p37Ss4-nkZxG7vLyv',
    defaultMessage: 'You need {credits, number} Status Credits & {nights, plural, one {# night} other {# nights}} by {expiryDate} to retain Platinum Status.',
    description: 'Remaining Platinum retention requirements for the current year in the double rewards selection',
  }, { credits: creditsRemaining, nights: nightsRemaining, expiryDate })
}

export default LoyaltyPlatinumRetentionMessage
